import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosDisponiveisInternet from './FiltrosAdicionadosDisponiveisInternet'
import FiltroRotas from './FiltroDisponiveisInternet'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroDisponiveisInternet = () => (
  <Filtro PainelFiltro={FiltroRotas}/>
);

const PainelFiltrosRotas = () => (
  <PainelFiltragem
    Filtro={PainelFiltroDisponiveisInternet}
    FiltrosAdicionados={FiltrosAdicionadosDisponiveisInternet}/>
)

export default PainelFiltrosRotas
